function overagePrice(pricingRange, quantity) {
  return ((quantity - pricingRange.end_quantity)
  * parseFloat(pricingRange.overage_price));
}

function priceWithOverage(pricingRange, quantity, price) {
  return price + (pricingRange.price * pricingRange.end_quantity)
  + overagePrice(pricingRange, quantity);
}

function calculate(pricingRange, quantity, price) {
  const overageQuantity = pricingRange.end_quantity ? pricingRange.end_quantity : Infinity;
  if (quantity <= overageQuantity) return price + (quantity * parseFloat(pricingRange.price));
  return priceWithOverage(pricingRange, quantity, price);
}

function volumeUsage(pricingRange, quantity, price) {
  const calculedQuotations = pricingRange
    .filter((range) => quantity >= range.start_quantity)
    .map((quo) => (
      {
        pricingRange,
        price: calculate(quo, quantity, parseFloat(price)),
      }));

  return calculedQuotations.filter((pre) => pre.price)[0].price;
}

export default volumeUsage;
